// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606300304/js/" + chunkId + "." + {"44":"7c46ab8b","225":"7b88851b","481":"6c0ddd69","486":"fb19d28b","770":"e049cfd5"}[chunkId] + ".0.35657722625735166.chunk.js";
};